export const triggerFileDownload = (
    url: string,
    cleanupDelayMs = 60_000,
): void => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.setAttribute("aria-hidden", "true");
    iframe.src = url;

    document.body.appendChild(iframe);

    window.setTimeout(() => {
        iframe.remove();
    }, cleanupDelayMs);
};
